// extracted by mini-css-extract-plugin
export var flush = "zimY9Nt0Shof2gcH9FJw";
export var headerWithIcon = "eqvs7L7IvmNOAHVNjAy7";
export var leftBorder = "ixJ8Fv0aWR1QpWdc0Q2w";
export var leftBorderInfo = "TiDGqsl3vdMn3wC7teUt";
export var leftBorderNegative = "m2BlehbcL1VQKOdpkoIh";
export var leftBorderPositive = "CX8t93MYRQYLSOgWpqld";
export var leftBorderWarning = "qE4arcpUai67lVjmECeL";
export var message = "NnjyD4aBZ0eTtgPsqbFp";
export var messageHeader = "XrxcWD9BVyQlmT6OzSZz";
export var trailingItem = "I2x4vIs5PBhb3khBwiKL";
export var vertical = "AAXSOiLnjKx9crJfrHLA";